import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import ReactRouterPropTypes from 'react-router-prop-types'
import { withRouter } from 'react-router-dom'
import styled from 'styled-components'
import _ from 'lodash'
import { isMobile } from 'react-device-detect'
import { injectIntl, FormattedMessage } from 'react-intl'

import MainContentWrapper from 'core/templates/MainContentWrapper'
import { getCurrency } from 'core/utils/cultures/unit'
import useGetConfigurator from 'core/hooks/useGetConfigurator'
import * as routes from 'core/routing/constants/index'
import PageLoading from 'core/components/page-loading'
import { Row, Col, Collapse, List, Checkbox, Empty, Input } from 'core/components/ui'
import wizardsShape from 'core/components/wizard/shapes'
import { font, greys } from 'assets/themes/theme-default'
import TitleIcon from 'core/layouts/title-icon'

import { configuratorShape } from '../shapes'
import {
  REFERENTIAL_AUTOVISTA_BE,
  REFERENTIAL_AUTOVISTA_ES,
  REFERENTIAL_AUTOVISTA_FR,
  REFERENTIAL_AUTOVISTA_IT,
  REFERENTIAL_AUTOVISTA_PT,
  REFERENTIAL_DAT_DE,
  REFERENTIAL_JATO_ES,
  REFERENTIAL_JATO_IT,
  REFERENTIAL_SANGUINETTI_IT,
  isReferentialAutovista
} from '../../core/utils/enums/referential'

const { Panel } = Collapse

const SearchWrapper = styled.div`
  margin: 0 0 25px 0;
`

const ClickableRow = styled(Row)`
  cursor: pointer;
  line-height: ${isMobile && 'normal'};
`
const ColDataInput = styled(Col)`
  padding-top: 2px;
`

const ColDataLabel = styled(Col)`
  color: ${greys.dark1};
  font-weight: ${font.weight.base};
`

const SubGroupLabel = styled.h4`
  color: ${greys.dark1};
  font-weight: ${font.weight.base};
  font-size: ${font.size.base};
  border-bottom: 1px solid ${greys.dark3};
`
const ListWrapper = styled.div`
  padding-left: ${isMobile ? '10px' : '50px'};
`
const ColDataValue = styled(Col)`
  text-align: right;
  color: ${props => props.theme.colors.color2.bg};
  font-weight: ${font.weight.bold};
`

const Options = props => {
  const { configurator, setConfigurator, intl, setWizards, wizards, history, campaign } = props

  const { idReferential } = campaign

  const { loading, carOptions, getOptions } = useGetConfigurator({
    redirectMessage: intl.formatMessage({ id: 'ui-session-expired' })
  })
  const [list, setList] = useState([])

  const { options, optionsList } = configurator

  const { equipmentGroups, equipments } = optionsList

  //const { optionsList } = configurator

  const generateOptionsListAutovista = filter => {
    const filteredEquipments = equipments.filter(equipment => {
      if (equipment.serial) return false
      const labels = equipment.equipment
      const allLabels = labels.toLowerCase().split(' ')

      const isPresent = filter
        ? _.first(filter.map(fil => allLabels.filter(word => word.includes(fil)))).length > 0
        : true
      return isPresent
    })

    const isIncludedInGroup = (equipment, groupId) => {
      if (!equipment.equipmentGroups) {
        return
      }
      // eslint-disable-next-line consistent-return
      return equipment.equipmentGroups.includes(groupId)
    }

    const generatedOptionsList = equipmentGroups.map(group => {
      const subGroupsList = group.equipmentSubGroups
        .map(subGroup => {
          // Equpi
          const equipmentList = filteredEquipments.filter(equipment => {
            const currentEquipmentGroups = equipment.equipmentGroups
            const currentEquipmentSubGroups = equipment.equipmentSubGroups

            const filtredEquipmentGroups = currentEquipmentGroups.filter(g => g === group.id)
            const filtredEquipmentSubGroups = currentEquipmentSubGroups.filter(
              g => g === subGroup.id
            )

            return filtredEquipmentGroups.length > 0 && filtredEquipmentSubGroups.length > 0
          })

          if (equipmentList.length > 0) {
            return {
              label: subGroup.subGroup,
              id: subGroup.id,
              items: equipmentList
            }
          }
          return null
        })
        .filter(subgroup => subgroup)
      if (!subGroupsList.length > 0 && group.id) {
        const scopedEquipments = filteredEquipments.filter(x => isIncludedInGroup(x, group.id))
        return {
          label: group.group,
          id: group.id,
          items: [{ id: null, label: null, items: scopedEquipments }]
        }
      }

      return {
        label: group.group,
        id: group.id,
        items: subGroupsList
      }
    })

    return generatedOptionsList.filter(option => option)
  }

  const generateOptionsListJato = filter => {
    const filteredEquipments = equipments.filter(equipment => {
      const labels = equipment.equipment
      const allLabels = labels.toLowerCase().split(' ')

      const isPresent = filter
        ? _.first(filter.map(fil => allLabels.filter(word => word.includes(fil)))).length > 0
        : true
      return isPresent
    })

    const listPack = {
      label: 'pack',
      id: 'pack',
      items: filteredEquipments.filter(equipement => !equipement.serial && equipement.pack)
    }

    const listOptions = {
      label: 'Options',
      id: 'otions',
      items: filteredEquipments.filter(equipement => !equipement.serial && !equipement.pack)
    }

    return [listPack, listOptions].filter(option => option)
  }

  const generateOptionsList = filters => {
    const filter = filters && filters.toLowerCase().split(' ')

    switch (idReferential) {
      case REFERENTIAL_AUTOVISTA_FR:
      case REFERENTIAL_SANGUINETTI_IT:
      case REFERENTIAL_AUTOVISTA_ES:
      case REFERENTIAL_AUTOVISTA_IT:
      case REFERENTIAL_AUTOVISTA_BE:
      case REFERENTIAL_AUTOVISTA_PT:
      case REFERENTIAL_DAT_DE:
      default:
        return generateOptionsListAutovista(filter)
      case REFERENTIAL_JATO_ES:
      case REFERENTIAL_JATO_IT:
        return generateOptionsListJato(filter)
    }
  }

  const activateNextStep = () => {
    const aStepsActive = wizards[wizards.activeWizard]

    const nextIndex = aStepsActive.findIndex(step => step.hash === routes.CONFIGURATOR_OPTIONS) + 1

    const extendedStep = { ...aStepsActive[nextIndex], isActive: true }

    const extendedSteps = Object.assign([...aStepsActive], {
      [nextIndex]: extendedStep
    })

    const extentedWizards = { ...wizards, aStepsConfigurator: extendedSteps }
    setWizards(extentedWizards)
  }

  const handleChangeSearchWord = e => {
    const { target } = e
    const { value } = target

    setList(generateOptionsList(value))
  }

  const handleOnChangeSelectionOptions = item => {
    const isSelected = !options ? false : options.filter(el => el.id === item.id).length > 0

    let extendedOptions = options ? [...options] : []

    if (!isSelected) {
      let carEquipmentGroupings = null

      if (isReferentialAutovista(idReferential) || idReferential === REFERENTIAL_SANGUINETTI_IT) {
        const filteredEquipementGroup = equipmentGroups.filter(group =>
          item.equipmentGroups.includes(group.id)
        )

        carEquipmentGroupings = item.equipmentSubGroups.map(sub => {
          const res = filteredEquipementGroup
            .filter(group => group.equipmentSubGroups.filter(el => el.id === sub).length > 0)
            .map(group => ({
              groupId: group.id,
              group: group.group,
              code: group.code,
              ...(() => {
                const result = group.equipmentSubGroups.find(subGroup => subGroup.id === sub)
                return {
                  subgroup: result.subGroup,
                  subgroupId: result.id
                }
              })()
            }))

          return res
        })
      }
      extendedOptions.push({ ...item, carEquipmentGroupings })
    } else {
      extendedOptions = options.filter(el => el.id !== item.id)
    }
    setConfigurator({
      ...configurator,
      options: extendedOptions
    })
  }

  const renderItems = items => (
    <ListWrapper>
      <List
        dataSource={items}
        renderItem={item => {
          const isChecked = !options ? false : options.filter(el => el.id === item.id).length > 0

          return (
            <List.Item>
              <ClickableRow
                type="flex"
                style={{ width: '100%' }}
                align="top"
                gutter={5}
                onClick={() => handleOnChangeSelectionOptions(item)}
              >
                <ColDataInput span={isMobile ? 3 : 1}>
                  <Checkbox checked={item.serial || isChecked} disabled={item.serial} />
                </ColDataInput>

                <ColDataLabel span={isMobile ? 14 : 20}>{item.equipment}</ColDataLabel>
                <ColDataValue span={isMobile ? 5 : 3}>
                  {item.inclVatPrice > 0 ? (
                    <>
                      <FormattedMessage
                        id="configurator-options-optionsList-card-price"
                        values={{ price: item.inclVatPrice }}
                        data-test="options-options-card-options-card-item-OptionCardItem-formattedPrice"
                      />{' '}
                      {getCurrency()}
                    </>
                  ) : (
                    <FormattedMessage
                      id="configurator-options-optionsList-card-included"
                      data-test="options-options-card-options-card-item-OptionCardItem-priceIncluded"
                    />
                  )}
                </ColDataValue>
              </ClickableRow>
            </List.Item>
          )
        }}
      />
    </ListWrapper>
  )

  const renderSubGroup = subGroup => {
    const { label, items, id } = subGroup
    return (
      <div key={id}>
        <SubGroupLabel>{label}</SubGroupLabel>
        {renderItems(items)}
      </div>
    )
  }

  const renderList = () =>
    list.map(group => {
      const { label, items, id } = group
      return (
        <Collapse
          key={id}
          bordered={false}
          expandIconPosition="right"
          defaultActiveKey={['1']}
          style={{ marginBottom: '10px' }}
        >
          <Panel header={label} key={1}>
            {[REFERENTIAL_AUTOVISTA_FR, REFERENTIAL_SANGUINETTI_IT, REFERENTIAL_DAT_DE].includes(
              idReferential
            ) && items.map(subGroup => renderSubGroup(subGroup))}
            {[REFERENTIAL_JATO_ES, REFERENTIAL_JATO_IT].includes(idReferential) &&
              renderItems(items)}
          </Panel>
        </Collapse>
      )
    })

  useEffect(() => {
    const runIt = () => {
      const optList = generateOptionsList()
      setList(optList)
    }

    if (equipmentGroups && equipments) runIt()
  }, [equipmentGroups, equipments])

  useEffect(() => {
    const runIt = l => {
      setConfigurator({
        ...configurator,
        optionsList: l
      })

      const genList = generateOptionsList()
      setList(genList)
    }

    if (carOptions) runIt(carOptions)
  }, [carOptions])

  useEffect(() => {
    // Redirection if direct access & step is not active

    const aStepsActive = wizards[wizards.activeWizard]

    const extendedStepsActive = aStepsActive.filter(
      step => step.hash === routes.CONFIGURATOR_OPTIONS
    )
    const currentStep = extendedStepsActive[0]

    const { isActive } = currentStep

    if (!isActive) {
      history.push(routes.HOME)
    }

    const { motor } = configurator
    const { id, catalog } = motor
    const params = { id, catalog }

    getOptions(params)

    activateNextStep()
  }, [])

  return (
    <MainContentWrapper
      title={intl.formatMessage({
        id: 'tradeIn-options-view-title'
      })}
    >
      {loading ? (
        <PageLoading />
      ) : (
        <>
          <TitleIcon
            title={intl.formatMessage({
              id: 'tradeIn-options-subtitle'
            })}
          />
          <Row type="flex" justify="center">
            <Col lg={isMobile ? 24 : 16} xs={24}>
              <SearchWrapper>
                <Input
                  placeholder={intl.formatMessage({
                    id: 'tradeIn-options-optionsList-search-placeholder'
                  })}
                  onChange={handleChangeSearchWord}
                />
              </SearchWrapper>
              {optionsList && optionsList.equipments.length > 0 ? renderList() : <Empty />}
            </Col>
          </Row>
        </>
      )}
    </MainContentWrapper>
  )
}

Options.propTypes = {
  history: ReactRouterPropTypes.history.isRequired,
  setWizards: PropTypes.func.isRequired,
  wizards: wizardsShape.isRequired,
  intl: PropTypes.shape().isRequired,
  setConfigurator: PropTypes.func.isRequired,
  configurator: configuratorShape.isRequired,
  campaign: PropTypes.shape().isRequired
}

export default withRouter(injectIntl(Options))
